import {FC, useState} from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import {
  createTheme,
  ThemeProvider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import { CustomizedTableFooter } from "../../../custom/CustomizedTableFooter";
import { useStyles } from "../../../../shared/styles/useStyles";
import { AppState } from "../../../../redux/reducers/rootReducer";
import { SeriesBody } from "./SeriesBody";
import { Colors } from "../../../../shared/constants/themes/Colors";
import { ITrdSeries } from "../../../../redux/types/types";
import { counter } from "../../../../helpers/count";

const theme = createTheme({
  typography: {
    fontFamily: "Poppins",
    fontSize: 11,
  },
});
interface props {
  series: ITrdSeries[];
}
export const SeriesTable: FC<props> = ({series}) => {
  const classes = useStyles();
  //const { series } = useSelector((state: AppState) => state.trd);
  const { data = [], value } = useSelector((state: AppState) => state.search);

  // Paginación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const count = counter( value, series, data );
  const filteredList: ITrdSeries[] = value.trim() ? (data as ITrdSeries[]) : series;
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredList.length - page * rowsPerPage);


  return (
    <ThemeProvider theme={theme}>
      <TableContainer component={Paper}>
        {series.length <= 0 ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{ height: 200 }}
            className={classes.title}
          >
            <InfoOutlinedIcon style={{ fontSize: 30, color: Colors.ACCENT }} />
            <FormattedMessage id={"NoCreatedSeries"} />
          </Box>
        ) : (
          <Table
            className={classes.table}
            size="small"
            style={{ tableLayout: "auto" }}
            aria-label="a dense table"
          >
            <TableHead className={classes.titleTable}>
              <TableRow>
                <TableCell
                  width={"15%"}
                  align="center"
                  className={classes.titleTable}
                >
                  <FormattedMessage id="CodeOP" />{" "}
                </TableCell>
                <TableCell align="center" className={classes.titleTable}>
                  <FormattedMessage id="ProductionOffice" />{" "}
                </TableCell>
                <TableCell align="center" className={classes.titleTable}>
                  <FormattedMessage id="SeriesCode" />{" "}
                </TableCell>
                <TableCell align="center" className={classes.titleTable}>
                  <FormattedMessage id="SeriesName" />{" "}
                </TableCell>
                <TableCell
                  width={"20%"}
                  className={classes.titleTable}
                  align="center"
                >
                  <FormattedMessage id="Actions" />{" "}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!value.trim()
                ? (rowsPerPage > 0
                    ? series.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                    : series
                  ).map((row) => (
                    <SeriesBody key={row.serieCode} serie={row} />
                  ))
                : data &&
                  (rowsPerPage > 0
                    ? data.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                    : data
                  ).map((row) => (
                    <SeriesBody key={row.serieCode} serie={row} />
                  ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 13 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {/* --------- Footer para paginación -------- */}
            <CustomizedTableFooter
              count={count}
              page={page}
              rowsPerPage={rowsPerPage}
              onChangePage={(_, newPage) => setPage(newPage)}
              onChangeRowsPerPage={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
            />

          </Table>
        )}
      </TableContainer>
    </ThemeProvider>
  );
};
